// Dashboard-level views.
//
// Each view defines the geometry for the entire dashboard and the base widget
// assignment for that view. Users can customize assignments afterward through
// the dashboard configuration modal.

const FLOWMAP_BASE_PANELS = [
  {
    id: 'p1',
    widgets: ['flowmap'],
    activeTab: 'flowmap',
  },
  {
    id: 'p2',
    widgets: ['miFeed'],
    activeTab: 'miFeed',
  },
  {
    id: 'p3',
    widgets: ['condensedChain'],
    activeTab: 'condensedChain',
  },
];

const PRICE_CHART_PANELS = [
  {
    id: 'p1',
    widgets: ['chart'],
    activeTab: 'chart',
  },
  {
    id: 'p2',
    widgets: ['miFeed'],
    activeTab: 'miFeed',
  },
  {
    id: 'p3',
    widgets: ['condensedChain'],
    activeTab: 'condensedChain',
  },
];

export const DASHBOARD_VIEWS = {
  flowmapBase: {
    id: 'flowmapBase',
    label: 'Flowmap',
    layoutId: 'tri-right-stack',
    panelCount: 3,
    panels: FLOWMAP_BASE_PANELS,
  },

  firstFlows: {
    id: 'firstFlows',
    label: 'First Flows',
    layoutId: 'quad',
    panelCount: 4,
    panels: [
      {
        id: 'p1',
        widgets: ['flowmap'],
        activeTab: 'flowmap',
      },
      {
        id: 'p2',
        widgets: ['miFeed'],
        activeTab: 'miFeed',
      },
      {
        id: 'p3',
        widgets: ['deltaFlowMeter'],
        activeTab: 'deltaFlowMeter',
      },
      {
        id: 'p4',
        widgets: ['condensedChain'],
        activeTab: 'condensedChain',
      },
    ],
  },

  zeroGex: {
    id: 'zeroGex',
    label: '0 GEX',
    layoutId: 'quad',
    panelCount: 4,
    panels: [
      {
        id: 'p1',
        widgets: ['flowmap'],
        activeTab: 'flowmap',
      },
      {
        id: 'p2',
        widgets: ['miFeed'],
        activeTab: 'miFeed',
      },
      {
        id: 'p3',
        widgets: ['gexPhaseDeltaFlow'],
        activeTab: 'gexPhaseDeltaFlow',
      },
      {
        id: 'p4',
        widgets: ['deltaFlowMeter'],
        activeTab: 'deltaFlowMeter',
      },
    ],
  },

  trend: {
    id: 'trend',
    label: 'Trend',
    layoutId: 'quad',
    panelCount: 4,
    panels: [
      {
        id: 'p1',
        widgets: ['flowmap'],
        activeTab: 'flowmap',
      },
      {
        id: 'p2',
        widgets: ['miFeed'],
        activeTab: 'miFeed',
      },
      {
        id: 'p3',
        widgets: ['gexTrendMonitor'],
        activeTab: 'gexTrendMonitor',
      },
      {
        id: 'p4',
        widgets: ['deltaFlowMeter'],
        activeTab: 'deltaFlowMeter',
      },
    ],
  },

  eodRange: {
    id: 'eodRange',
    label: 'EOD Range',
    layoutId: 'penta',
    panelCount: 5,
    panels: [
      {
        id: 'p1',
        widgets: ['flowmap'],
        activeTab: 'flowmap',
      },
      {
        id: 'p2',
        widgets: ['miFeed'],
        activeTab: 'miFeed',
      },
      {
        id: 'p3',
        widgets: ['eodRangeInsights'],
        activeTab: 'eodRangeInsights',
      },
      {
        id: 'p4',
        widgets: ['gexPhaseDeltaFlow'],
        activeTab: 'gexPhaseDeltaFlow',
      },
      {
        id: 'p5',
        widgets: ['gexTrendMonitor'],
        activeTab: 'gexTrendMonitor',
      },
    ],
  },

  priceChart: {
    id: 'priceChart',
    label: 'Chart',
    layoutId: 'tri-right-stack',
    panelCount: 3,
    panels: PRICE_CHART_PANELS,
  },
};

export const DASHBOARD_VIEW_LIST = [
  DASHBOARD_VIEWS.flowmapBase,
  DASHBOARD_VIEWS.firstFlows,
  DASHBOARD_VIEWS.zeroGex,
  DASHBOARD_VIEWS.trend,
  DASHBOARD_VIEWS.eodRange,
  DASHBOARD_VIEWS.priceChart,
];
